import focusElement from "./focus-element";
import {selectElement} from "../../lib/utils";
import showMsg from "./show-msg";
import event, {EVENTS} from "../../lib/event";
import Audio from "../../lib/audio";
import Cartoon from '../avatar-action';
import {BATCH_TIPS_MODE, GUIDE_MODE} from '../../lib/constant';

/**
 * 表单输入某个值，并校验，直到输入的值正确
 * @param element
 * @param index
 * @param value
 * @param tips
 * @returns {Promise<unknown>}
 */
export default async function formInput({element, index, value, tips}, mode, _index) {
    //代码中通过mode是否为undefined来判断是否要显示聊天记录，因此这里不能初始化 if (mode === undefined) mode = stepsRuntime.mode;
    if (_index === undefined) _index = {stepIndex: stepsRuntime.stepIndex, actionIndex: stepsRuntime.actionIndex};
    if (!tips) {
        tips = '请在这里输入『' + value + '』';
    }
    const newTips = tips + '，然后点击灰色背景继续下一步';
    return new Promise(async (resolve, reject) => {
        const _element = await selectElement(element, index);
        if (_element) {
            if (mode) {
                window.stepsRuntime.insertTips(_index, tips);
                if (mode === BATCH_TIPS_MODE) {
                    resolve();
                    return;
                }
            }else {
                Audio.tts(newTips);
            }
            _element.onkeydown = e => {
                if (e.code === 'Enter') {
                    event.emit(EVENTS.BG_CLICK);
                    e.preventDefault();
                    /*
                    if (_element.value !== value) {
                        e.preventDefault();
                        showMsg({title: `输入值『${_element.value}』与期望值『${value}』不匹配，请重新输入`});
                    }else {
                        event.emit(EVENTS.BG_CLICK);
                        resolve();
                    }*/
                }
            };
            focusElement({element, index, tips: newTips, pointerEvents: 'none'}).then(()=>{
                if (_element.value !== value) {
                    return showMsg({title: `输入值『${_element.value}』与期望值『${value}』不匹配，请重新输入`}, mode, _index).then(() => formInput({
                        element,
                        index,
                        value,
                        tips
                    }));
                }
            }).then(resolve, reject);
        }else {
            if (mode) {
                window.stepsRuntime.insertTips(_index, tips);
                if (mode === GUIDE_MODE) {
                    reject('没有找到：' + element);
                }else {
                    resolve();
                }
            }else {
                Audio.tts(tips);
                reject('没有找到：' + element);
            }

        }
    });

}
